import api, { STORAGE_KEY } from './api';

const API_URL = '/users';

export const getUsers = async () => {
    const response = await api.get(API_URL);
    return response.data;
};

export const updateUserStatus = async (userId, status) => {
    const response = await api.patch(`${API_URL}/${userId}/status`, { status });
    return response.data;
};

export const setAuthData = (data) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getAuthData = () => {
    return JSON.parse(localStorage.getItem(STORAGE_KEY));
};

export const createUser = async (userData) => {
    const response = await api.post(API_URL, userData);
    return response.data;
};
